import { render } from "./OrgEditor.vue?vue&type=template&id=7a91791c"
import script from "./OrgEditor.vue?vue&type=script&lang=js"
export * from "./OrgEditor.vue?vue&type=script&lang=js"

import "./OrgEditor.vue?vue&type=style&index=0&id=7a91791c&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__